import React from "react";
import {
  Box,
  Typography,
  Divider,
  useTheme,
} from "@mui/material";

const UserAgreement = () => {
  const theme = useTheme();

  return (
    <Box sx={{ bgcolor: "#f4f6f8", py: 6, px: { xs: 3, sm: 8, md: 12 }, minHeight: "100vh" }}>
      <Box
        sx={{
          bgcolor: "#ffffff",
          borderRadius: 2,
          boxShadow: 2,
          p: { xs: 3, sm: 5, md: 7 },
        }}
      >
        <Typography
          variant="h3"
          component="h1"
          gutterBottom
          sx={{ fontWeight: 700, color: "#0A1929" }}
        >
          User Agreement
        </Typography>

        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{ color: "text.secondary", mb: 3 }}
        >
          Effective Date: August 01, 2025
        </Typography>

        <Typography variant="body1" sx={{ mb: 3 }}>
          This <strong>User Agreement</strong> is a legal agreement between you ("User") and <strong>WorkPulse.in</strong>,
          the provider of the WorkPulse project and task management platform. By accessing or using the WorkPulse application
          or website (<code>www.WorkPulse.in</code>), you agree to comply with and be bound by the terms and conditions outlined
          below.
        </Typography>

        <Divider sx={{ mb: 4 }} />

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          1. License Grant
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          WorkPulse.in grants you a limited, non-exclusive, non-transferable, and revocable license to access and use the
          platform for internal business or professional use, in accordance with this Agreement.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          2. Restrictions on Use
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          You agree not to:
          <ul style={{ paddingLeft: "1.5rem", marginTop: "0.5rem" }}>
            <li>Modify, reverse engineer, decompile, or disassemble any part of the platform.</li>
            <li>Rent, lease, sublicense, sell, or commercially exploit the platform without permission.</li>
            <li>Use the platform for unlawful, unauthorized, or malicious purposes.</li>
            <li>Access other user data without authorization.</li>
            <li>Disrupt or interfere with platform performance.</li>
          </ul>
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          3. Ownership and Intellectual Property
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          All rights, titles, and interests in and to the platform remain the exclusive property of <strong>WorkPulse.in</strong>.
          This Agreement does not grant you ownership rights.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          4. Data Collection and Privacy
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Your use of the platform is governed by our <strong>Privacy Policy</strong>, which outlines how we handle your data.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          5. Disclaimer of Warranties
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          The platform is provided "as is" without warranties of any kind. Use is at your sole risk.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          6. Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          <strong>WorkPulse.in</strong> shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use or inability to use the platform.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          7. Termination
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          We may suspend or terminate access at any time if you breach this Agreement.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          8. Updates and Modifications
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          <strong>WorkPulse.in</strong> may modify the platform or terms at any time. Continued use means acceptance of changes.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          9. Governing Law
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          This Agreement is governed by Indian law. Jurisdiction lies with the courts in Mumbai, Maharashtra.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          10. Acceptance of Terms
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          By using the platform, you confirm acceptance of this Agreement.
        </Typography>

        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
          11. Contact Information
        </Typography>
        <Typography variant="body1">
          For questions or concerns, please contact us at <strong>support@workpulse.in</strong>.
        </Typography>
      </Box>
    </Box>
  );
};

export default UserAgreement;
